var spacingUnit = 6;
var unit = 'px';
export default (() => ({
  global: {
    spacingUnit: "".concat(spacingUnit).concat(unit),
    gutterSpacing: {
      mobile: "".concat(spacingUnit * 3).concat(unit),
      desktop: "".concat(spacingUnit * 4).concat(unit)
    },
    spacing: {
      desktop: {
        xlarge: "".concat(spacingUnit * 16).concat(unit),
        large: "".concat(spacingUnit * 8).concat(unit),
        medium: "".concat(spacingUnit * 4).concat(unit),
        small: "".concat(spacingUnit * 3).concat(unit),
        xsmall: "".concat(spacingUnit * 2).concat(unit)
      },
      mobile: {
        xlarge: "".concat(spacingUnit * 12).concat(unit),
        large: "".concat(spacingUnit * 6).concat(unit),
        medium: "".concat(spacingUnit * 4).concat(unit),
        small: "".concat(spacingUnit * 3).concat(unit),
        xsmall: "".concat(spacingUnit * 2).concat(unit)
      }
    }
  }
}));